import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatDialogModule } from "@angular/material/dialog";
import { FuseSharedModule } from "@fuse/shared.module";
import { ToolbarComponent } from "app/layout/components/toolbar/toolbar.component";
import { MatBadgeModule } from "@angular/material/badge";
import { DirectivesModule } from "app/shared/directives/directives.module";
import { LanguageSelectorModule } from "app/language-selector/language-selector.module";
import { TranslocoModule } from "@ngneat/transloco";
import { MatChipsModule } from '@angular/material/chips';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { NewFeatureStylingDirective } from "app/shared/directives/new-feature-styling.directive";

@NgModule({
  declarations: [ToolbarComponent],
  imports: [
    TranslocoModule,
    LanguageSelectorModule,
    MatBadgeModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatDialogModule,
    FuseSharedModule,
    DirectivesModule,
    MatChipsModule,
    MatProgressBarModule,
    NewFeatureStylingDirective
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
